import request from '@/api/request';

/*
    * Пришлось отказаться от такой структуры, так как grp не имеет своего уникального идентификатора.

    grpByWell: {
        100: [10, 50, 60] / удобно рисовать
    }
    grp: { / удобно искать в колонке
        10: { grp },
        50: { grp },
        60: { grp }
    }
*/

/*
    В будущем всё потребуется быстрый доступ к ГРП.
    TODO: Поэтому надо подумать, как ГРП выдать уникальный идентификатор (index или сгенерированный id)
*/

export const grpWellModel = {
    name: 'grpWell',
    state: {
        /*
            [wellId]: [grp, grp, ..., grp],
        */
        grpByWell: {},
    },
    reducers: {
        setGrpByWell(state, payload) {
            return { ...state, grpByWell: Object.assign({}, state.grpByWell, payload) };
        },
    },
    effects: {
        /*
            Принимает массив id скважин, по которым нужно получать информацию по ГРП
        */
        async getGrpWell(params) {
            const body = JSON.stringify({ wellId: params });

            /*
                * Node mock request:

                const response = await fetch('/api/grp', {
                    method: 'POST',
                    headers: new Headers({ 'Content-Type': 'application/json', 'Accept': 'application/json' }),
                    body: JSON.stringify(body),
                });

                const result = await response.json();
            */

            try {
                const response = await request.post(`logging/well-grp/`, { body }).json();
                const normalizeResult = normalize(params, response.GRPdata);

                this.setGrpByWell(normalizeResult.grpByWell);

                return normalizeResult.depth;
            } catch (error) {
                console.log('grp fetch error', error);
                return {};
            }
        },
    },
};

function toOject(ids) {
    const dictionary = {};

    for (const id of ids) {
        dictionary[id] = [];
    }

    return dictionary;
}

function normalize(wellIds, data) {
    const grpByWell = toOject(wellIds);
    const depth = toOject(wellIds);

    for (const item of data) {
        const { wellId } = item;

        if (wellId in grpByWell) {
            grpByWell[wellId].push(item);
            depth[wellId].push(item.lowerHolesDepth, item.upperHolesDepth);
        }
    }

    return {
        grpByWell,
        depth,
    };
}
